import { Container } from 'react-bootstrap'
import TimingConfiguration from './Cards/TimingConfiguration'
import HarvesterPowerSupervisory from './Cards/HarvesterPowerSupervisory'
import Capacitors from './Cards/Capacitors'

export default function Parameters() {
	return (
		<Container>
			<TimingConfiguration />
			<HarvesterPowerSupervisory />
			<Capacitors />
		</Container>
	)
}
